// 마이룸 환경 선택(?mr=test)을 화면 이동에 이어붙이기 위한 헬퍼.
//
// 이게 없으면 홈 배너 -> 마이채널 -> 방으로 넘어가는 사이 mr 이 떨어져서,
// 테섭을 테스트하려면 /myroom?mr=test 를 직접 열어야 한다. 실제 유저 동선으로
// 테스트하려면 진입점마다 현재 mr 을 물고 가야 한다.
//
// useSearchParams 훅 대신 window.location 을 직접 읽는 이유:
// /home 과 /mychannel/profile 은 정적 프리렌더 페이지라, 훅을 쓰면 Suspense 경계를
// 요구하며 빌드가 깨진다. mr 은 클릭·이펙트 시점에만 필요해서 그때 읽으면 충분하다.

export function currentMr(): string | undefined {
    if (typeof window === 'undefined') return undefined;
    const mr = new URLSearchParams(window.location.search).get('mr');
    return mr || undefined;
}

// 이동할 경로에 현재 mr 을 붙인다. mr 이 없으면 경로를 그대로 돌려준다.
export function withMr(path: string): string {
    const mr = currentMr();
    if (!mr) return path;
    return `${path}${path.includes('?') ? '&' : '?'}mr=${encodeURIComponent(mr)}`;
}
